// extracted by mini-css-extract-plugin
module.exports = {"container":"imageControls_container__uT2mt","label":"imageControls_label__1DVXc"};